import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightSections = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.90674 9.74906H12.2842L8.62424 13.4091C8.33174 13.7016 8.33174 14.1816 8.62424 14.4741C8.91674 14.7666 9.38924 14.7666 9.68174 14.4741L14.6242 9.53156C14.9167 9.23906 14.9167 8.76656 14.6242 8.47406L9.68924 3.52406C9.39674 3.23156 8.92424 3.23156 8.63174 3.52406C8.33924 3.81656 8.33924 4.28906 8.63174 4.58156L12.2842 8.24906H3.90674C3.49424 8.24906 3.15674 8.58656 3.15674 8.99906C3.15674 9.41156 3.49424 9.74906 3.90674 9.74906Z",
		fill: "#6B719D"
	})
});
export default SvgArrowRightSections;
